export default function Section({ children }: { children: React.ReactNode }) {
  return <div className="card">{children}</div>;
}
